import { render, staticRenderFns } from "./SlotEdit.vue?vue&type=template&id=87c1ad24&scoped=true"
import script from "./SlotEdit.vue?vue&type=script&lang=js"
export * from "./SlotEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c1ad24",
  null
  
)

export default component.exports